/**
 * Métodos de inicio de sesión soportados
 */
export enum ESignInMethod {
  GOOGLE = 'GOOGLE',
  PASSWORD = 'PASSWORD',
  MICROSOFT = 'MICROSOFT',
}
